
import { mapGetters, mapActions } from "vuex"
import filtersMixin from "@/mixins/filters"

export default {
  mixins: [filtersMixin],

  layoutProps: {
    titleToken: "exhibitors.title2",
  },

  // validate ({ store }) {
  //   return store.getters["user/isAdmin"]
  // },

  data: () => ({
    exhibitors: [],
  }),

  computed: {
    ...mapGetters("user", ["favoriteExhibitors", "isExhibitionAllowed"]),

    exhibitors_ () {
      return this.exhibitors.map(e => ({
        ...e,
        isFavorite: Boolean(this.favoriteExhibitors.find(fe => fe.id === e.id)),
      }))
    },
  },

  watch: {
    "filters.skParticipant" () {
      this.$set(this.filters, "competitionDirection", undefined)
    },
  },

  async mounted () {
    await this.fetchFavoriteExhibitors()
  },

  methods: {
    ...mapActions("user", ["fetchFavoriteExhibitors", "setFavoriteExhibitor"]),

    async filter () {
      const [res, err] = await this.$api.exhibition.getApps({
        params: this.params,
      })
      if (err) {
        console.error(err)
        return
      }
      this.exhibitors = res?.list || []
      this.paginator = res?.paginator || {}
    },

    async toggleFavorite (exhibitor) {
      await this.setFavoriteExhibitor({
        id: exhibitor.id, isFavorite: !exhibitor.isFavorite,
      })
      await this.filter()
    },
  },
}
